import React, { createContext, useState, useEffect } from 'react';

// إنشاء دالة للوصول إلى الدوال العالمية لتغيير اللغة
let globalLanguageCallbacks = {
  setArabic: null,
  setFrench: null,
  setEnglish: null
};

// تسجيل دوال تغيير اللغة من Langague.js
export const registerLanguageCallbacks = (callbacks) => {
  globalLanguageCallbacks = callbacks;
};

// إنشاء سياق اللغة للاستخدام في جميع المكونات
export const LanguageContext = createContext({
  language: 'fr',
  changeLanguage: () => {}
});

export const LanguageProvider = ({ children }) => {
  // إضافة حالة اللغة
  const [language, setLanguage] = useState(() => {
    // محاولة استرجاع اللغة المحفوظة
    const savedLanguage = localStorage.getItem('anpe-language');
    return savedLanguage || 'fr'; // اللغة الافتراضية هي الفرنسية
  });
  
  // دالة لتغيير اللغة
  const changeLanguage = (lang) => {
    if (['ar', 'fr', 'en'].includes(lang)) {
      setLanguage(lang);
      localStorage.setItem('anpe-language', lang);
      
      // تغيير اتجاه الصفحة
      document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
      document.documentElement.lang = lang;
      
      // استدعاء دوال تغيير اللغة العالمية
      if (globalLanguageCallbacks) {
        switch(lang) {
          case 'ar':
            if (globalLanguageCallbacks.setArabic) globalLanguageCallbacks.setArabic();
            break;
          case 'fr':
            if (globalLanguageCallbacks.setFrench) globalLanguageCallbacks.setFrench();
            break;
          case 'en':
            if (globalLanguageCallbacks.setEnglish) globalLanguageCallbacks.setEnglish();
            break;
          default:
            break;
        }
      }
    }
  };
  
  // تحديث الاتجاه والمغة عند التحميل
  useEffect(() => {
    document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = language;
  }, [language]);
  
  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

// دالة مساعدة للحصول على الترجمات حسب اللغة الحالية
export const getTranslation = (translations, language, key) => {
  if (!translations || !language || !key) return '';
  return translations[language]?.[key] || translations['fr']?.[key] || key;
};
